const HighlightLabels = (() => {
    function onFocusFormElement() {
        const $this = $(this);
        const row = $this.closest('.input-row');

        if (row && row.hasClass('js-input-placeholder')) {
            row.addClass('focus');
            if ($this.data('placeholder')) {
                $this.attr('placeholder', $this.data('placeholder'));
            }
        }
    }

    function onBlurFormElement() {
        const $this = $(this);
        const row = $this.closest('.input-row');

        if (row && row.hasClass('js-input-placeholder')) {
            row.removeClass('focus');
        }
    }

    function bindEvents() {
        $(document)
            .on('change blur', 'input, textarea, select', onBlurFormElement)
            .on('focus', 'input, textarea, select', onFocusFormElement);
    }

    function prepareForms() {
        bindEvents();
    }

    return {
        init() {
            if (!$('.js-input-placeholder').length) {
                return;
            }

            prepareForms();
        },
    };
})();

export default HighlightLabels.init;
